

const apiConfig = {
  // Set the base URL for your API
  apiUrl: '/',
};

export { apiConfig };
